import { useEffect, useState } from 'react';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const list = window.matchMedia(query);
    const update = () => setMatches(list.matches);
    update();
    list.addEventListener('change', update);
    return () => list.removeEventListener('change', update);
  }, [query]);

  return matches;
}

/**
 * The single breakpoint of the app: bottom bar and sheets below, sidebar and
 * centred dialogs from here up. Kept in one place so the layout and the
 * modal-shape decision can never disagree.
 */
export const DESKTOP_QUERY = '(min-width: 900px)';

export function useIsDesktop(): boolean {
  return useMediaQuery(DESKTOP_QUERY);
}

/** True on devices whose primary pointer is coarse — drives touch wording. */
export function useIsTouch(): boolean {
  return useMediaQuery('(pointer: coarse)');
}
